import { useState } from 'react';
import { ApiError, api } from '../lib/api';

/**
 * Banner persistente (v1.3.2) para users con email_confirmed === false. NO
 * bloquea el uso del app — solo invita a confirmar y permite reenviar el correo
 * (rate-limited a 1 cada 5 min en backend; reflejamos el cooldown en la UI).
 */
export function EmailConfirmationBanner() {
  const [state, setState] = useState<'idle' | 'sending' | 'sent' | 'cooldown'>('idle');
  const [msg, setMsg] = useState<string>('');

  const resend = async () => {
    setState('sending');
    setMsg('');
    try {
      await api('/auth/resend-email-confirmation', { method: 'POST', body: {} });
      setState('sent');
      setMsg('Correo reenviado. Revisa tu bandeja (y spam).');
    } catch (err) {
      if (err instanceof ApiError && err.status === 429) {
        const secs = Number(err.body?.retryAfterSeconds ?? 300);
        setState('cooldown');
        setMsg(
          err.body?.message ??
            `Espera ${Math.ceil(secs / 60)} min antes de reenviar.`,
        );
      } else {
        setState('idle');
        setMsg('No se pudo reenviar. Intenta más tarde.');
      }
    }
  };

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 bg-amber-50 px-4 py-2 text-center text-xs text-amber-800 ring-1 ring-amber-200">
      <span>
        Confirma tu correo para acceder a todas las funciones.
      </span>
      {msg && <span className="font-medium">{msg}</span>}
      {state !== 'sent' && (
        <button
          type="button"
          onClick={resend}
          disabled={state === 'sending' || state === 'cooldown'}
          className="rounded-full bg-amber-600 px-3 py-1 font-medium text-white transition hover:bg-amber-700 disabled:opacity-50"
        >
          {state === 'sending' ? 'Enviando…' : 'Reenviar correo'}
        </button>
      )}
    </div>
  );
}

export default EmailConfirmationBanner;
